import { useCallback, useEffect, useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Nav from './nav';
import { HeaderSlotContext } from './headerSlot';
import LeadAssignedPopup from '../../components/notifications/LeadAssignedPopup';
import { connectSocket, disconnectSocket } from '../../service/socket';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);

  // Header slot (see headerSlot.js). While a page uses it, the header can wrap
  // to more than one row, so the content is pushed down by its measured height.
  const [slotNode, setSlotNode] = useState(null);
  const [slotClaims, setSlotClaims] = useState(0);
  const [headerHeight, setHeaderHeight] = useState(null);
  const claimSlot = useCallback(() => {
    setSlotClaims((n) => n + 1);
    return () => setSlotClaims((n) => n - 1);
  }, []);
  const slot = useMemo(() => ({ node: slotNode, claim: claimSlot }), [slotNode, claimSlot]);
  const slotInUse = slotClaims > 0;

  useEffect(() => {
    connectSocket();
    return () => disconnectSocket();
  }, []);

  return (
    <HeaderSlotContext.Provider value={slot}>
      <StyledRoot>
        <Header
          onOpenNav={() => setOpen(true)}
          slotRef={setSlotNode}
          slotInUse={slotInUse}
          onHeightChange={setHeaderHeight}
        />

        <Nav openNav={open} onCloseNav={() => setOpen(false)} />

        <Main style={slotInUse && headerHeight ? { paddingTop: headerHeight + 24 } : undefined}>
          <Outlet />
        </Main>

        <LeadAssignedPopup />
      </StyledRoot>
    </HeaderSlotContext.Provider>
  );
}
